<template>
    <div>
        <Header>
            <h2>Contact Us</h2>
        </Header>
        <div class="container">
            <div class="row">
                <div class="col-xl-12">
                    <div class="contact-location-info margin-bottom-50">
                        <Address v-bind="contacts"></Address>
                    </div>
                </div>

                <div class="col-xl-8 col-lg-8 offset-xl-2 offset-lg-2">
                    <section id="contact" class="margin-bottom-60">
                        <h3 class="headline margin-top-15 margin-bottom-35">Any questions? Feel free to contact us!</h3>
                        <Form></Form>
                    </section>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/base/Header.vue';
import Address from './Address.vue';
import Form from './Form.vue';

export default {
    components: {
        Header,
        Address,
        Form
    },
    props: {
        contacts: {
            type: Object,
        },
    },
}
</script>